import React from "react";
import styles from "./ProductCreatePage.module.css";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import ProductFrom from "admin/components/Product/ProductForm/ProductFrom";

function ProductCreatePage(props) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Typography variant="h5" gutterBottom>
          Thêm Sản Phẩm
        </Typography>
      </div>
      <div>
        <ProductFrom />
      </div>
    </div>
  );
}

ProductCreatePage.propTypes = {};

export default ProductCreatePage;
